import ServiceCategoryPage from '@/components/business/ServiceCategoryPage';
import { makeServiceCategoryPaths, makeServiceCategoryProps } from '@/lib/serviceCategoryFactory';
import { BusinessItem } from '@/core/models/businesses/businessList';
import { GetStaticPaths, GetStaticProps } from 'next';

const CATEGORY_ID = '1775';
const CATEGORY_LABEL = 'Traffic Fines';
const CATEGORY_SLUG = 'traffic-fines';
const CATEGORY_DESCRIPTION = 'Find services to assist with traffic fine disputes and payments. Clear outstanding fines and warrants with professional assistance.';
const TAGS: string[] = ['Fine Disputes', 'Outstanding Fines', 'AARTO', 'Warrant Clearance'];

interface Props {
    businesses: BusinessItem[];
    pagination: { count: number; currentPage: number; totalPages: number };
    city: string;
    cityName: string;
}

export default function TrafficFinesCityPage({ businesses, pagination, city, cityName }: Props) {
    return (
        <ServiceCategoryPage
            businesses={businesses}
            pagination={pagination}
            city={city}
            cityName={cityName}
            categoryId={CATEGORY_ID}
            categoryLabel={CATEGORY_LABEL}
            categorySlug={CATEGORY_SLUG}
            categoryDescription={CATEGORY_DESCRIPTION}
            tags={TAGS}
        />
    );
}

export const getStaticPaths: GetStaticPaths = makeServiceCategoryPaths();
export const getStaticProps: GetStaticProps = makeServiceCategoryProps(CATEGORY_ID);
